
import { mdiDelete } from "@mdi/js"
import Modal from "@/components/base/modal/Modal"
import OabatTextFieldSearchIcon from "@/components/base/design/OabatTextFieldSearchIcon"
import TypingPlaceholder from "@/components/base/input/TypingPlaceholder"

export default {
    name: "SearchWrapper",
    components: {
        OabatTextFieldSearchIcon,
        Modal,
        TypingPlaceholder,
    },
    /** open:
     * clear: if search should be cleared
     * input: dialogs open state for v-model binding
     */
    emits: ["clear", "input"],
    props: {
        /** Dialogs open state - v-model */
        value: {
            type: Boolean,
            default: false,
        },
        /** Currently searched string */
        search: {
            type: String,
            default: "",
        },
        /** Placeholder suggestions with typing animation */
        suggestions: {
            type: Array,
            default: () => [],
        },
        /** Placeholder string. Replace suggestion slot with %s */
        placeholder: {
            type: String,
            default: "Gib z.B.",
        },
    },
    data() {
        return {
            mdiDelete,
        }
    },
    computed: {
        isSearchEmpty() {
            return this.search?.length < 1
        },
        prefix() {
            const parts = this.placeholder.split("%s")
            if (parts.length < 1) return ""
            return parts[0]
        },
        suffix() {
            const parts = this.placeholder.split("%s")
            if (parts.length < 2) return ""
            return parts[1]
        },
        dialog: {
            get() {
                return this.value
            },
            set(newVal) {
                this.$emit("input", newVal)
            },
        },
    },
    methods: {
        toggleModal() {
            this.dialog = !this.dialog
        },
    },
}
